import { setLanguage } from "@languages/index";
import { SET_PREFERENCES } from "./types";

const initialState = {
  preferences: {
    locale: undefined,
    notify: true,
    tabBarHeight: 0,
    signIn: {
      email: "",
    },
    scrollY: 0,

    previousRouteName: undefined,
    previousRouteKey: undefined,
    previousRouteParams: undefined,
    currentRouteKey: undefined,
    currentRoute: null,
    tabPress: undefined,
    isFirstRunning: false,
    filterNotAavailableProducts: true,
    isMatchRatingSettingCautionModalDisabled: false,
    isAmbassadorApplicantsListCautionModalDisabled: false,
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_PREFERENCES:
      let { locale } = action.payload;
      if (locale != null) {
        setLanguage(locale);
      }
      return {
        ...state,
        preferences: { ...state.preferences, ...action.payload },
      };
    default:
      return state;
  }
}
export default reducer;
